
import Footer from 'umg-components/src/components/organisms/Footer.vue'
import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { cms } from '../../cms'
import { TranslationHandler } from '../mixins/TranslationHandler'

@Component({
  components: { Footer },
})
export default class AppFooter extends Mixins(TranslationHandler) {
  @Action('USER_LOGOUT') userLogout!: () => Promise<void>
  @Getter userDisplayName!: string
  @Getter userProfilePicture!: string

  @Getter competitionIsEnabled!: boolean

  @Getter visualPrimaryColor!: string
  @Getter visualIsDark!: boolean
  @Getter visualFont!: string

  get translations() {
    const translations = {
      userLogoutHeadline: this.$t('footerUserLogoutHeadline'),
      userLogooutButton: this.$t('footerUserLogooutButton'),
      links: [
        { label: this.$t('faqLabel') },
        { label: this.$t('footerLinksTitleImprint'), href: this.$t('footerLinksLinkImprint') },
        { label: this.$t('footerLinksTitlePrivacy'), href: this.$t('footerLinksLinkPrivacy') },
      ]
    }

    if (this.competitionIsEnabled) {
      translations.links.push(
        { label: this.$t('footerLinksTitleTerms'), href: this.$t('footerLinksLinkTerms') }
      )
    }

    return translations
  }

  get backround() {
    return this.visualIsDark ? ' #0D1114' : '#263451'
  }

  linkClick(url: string) {
    if (url === 'FAQ') {
      this.$emit('faqOpen')
      return
    }

    cms.tracking.trackNavigation('navigation', { navigation_item: url })
  }

  async logout() {
    await this.userLogout()
    window.location.reload()
  }
}
